/* eslint-disable */
import base from '@bingads-webui-static-legacy/wunderbar/data/collections/base';
import model from '@bingads-webui-static-legacy/wunderbar/data/models/adgroup';
var collection = base.extend({
  model: model.backbone,
  url: '/Campaign/WunderBar/GetAdGroups'
});
export default collection;

